import { action, computed, makeAutoObservable } from "mobx";
import {Winner} from "../types";


export class WinnerStore {
  private winners = new Map<string, Winner>();

  constructor() {
    makeAutoObservable(this);
  }

  @computed
  has(winner: Winner): boolean {
    return this.winners.has(winner.address);
  }

  @action
  add(winner: Winner): void {
    this.winners.set(winner.address, winner);
  }

  @action
  clear() {
    this.winners.clear();
  }

  @computed
  size() {
    return this.winners.size;
  }

  @computed
  getWinners(): Winner[] {
    return [...this.winners.values()];
  }
}
